import { useQuery } from "graphql-hooks";
import { useEffect, useState } from "react";
import { Col, Row } from 'reactstrap';
import { SiteNavigation } from "./SiteNavigation";
import { TopNavigation } from "./TopNavigation";
import { clientConfig } from "../../../utilities/configService";
import { useLocation } from "react-router";
import { NavLink } from "react-router-dom";
import { useAPIErrorContext } from '../../../contexts/apiErrorContext';

const CMS_QUERY = `query datoQuery {
  websiteConfiguration {
    fieldWebsiteTitle
    fieldWebsiteLogo {
      alt
      url
      title
      width
      height
    }
  }
}`;

export const Header = () => {
    const { loading, error, data } = useQuery(CMS_QUERY, {
        variables: {
            limit: 10
        }
    });
    const { trackError } = useAPIErrorContext();
    const [showMobileNavigation, setShowMobileNavigation] = useState(false);

    const showHideMobileNavigation = (e: any) => {
        e.preventDefault();

        if (showMobileNavigation) {
            setShowMobileNavigation(false);
        }
        else {
            setShowMobileNavigation(true);
        }
    };

    const location = useLocation();
    useEffect(() => {
        setShowMobileNavigation(false);
    }, [location]);


    if (!error && !loading) {
        return (
            <header className="container-fluid header">
                <Row className="headerContainer">
                    <Col lg={9} md={7} sm={12} className="logoContainer">
                        <Row className="logoContainerRow">
                            <Col sm="auto" className="logoImage">
                                <NavLink className="logoLink" key="Home" to="/" >
                                    <img src={data.websiteConfiguration.fieldWebsiteLogo.url} className="logo" alt={data.websiteConfiguration.fieldWebsiteLogo.alt} />
                                </NavLink>
                            </Col>
                            <Col sm="auto" className="programName">
                                <NavLink className="logoLink" key="Home" to="/" >
                                    {data.websiteConfiguration.fieldWebsiteTitle}
                                </NavLink>
                            </Col>
                        </Row>
                    </Col>
                    <Col lg={2} md={4} sm={12}>
                        <Row>
                            <div className="mainMenuTabs desktopView">
                                <TopNavigation />
                            </div>
                        </Row>
                    </Col>
                </Row>
                <Row>
                    <Col className="desktopView menuContainer">
                        <SiteNavigation />
                    </Col>
                </Row>
                <Row className="mainMenuTabs mobileView">
                    <Col className="mobileMenuHeader">
                        <div className="hamburgerLabel" onClick={showHideMobileNavigation} />
                        {showMobileNavigation && (
                            <div className="closeMenuButton" onClick={showHideMobileNavigation} />
                        )}
                        {showMobileNavigation ? (
                            <div className="showHideNavigation">
                                <SiteNavigation />
                                <TopNavigation />
                            </div>
                        ) : (<></>)}
                    </Col>
                </Row>
            </header>
        )
    } else if (!loading) {
        trackError("Dato error", JSON.stringify(error));
        return (
            <header className="container-fluid header">
                <Row className="headerContainer">
                    <Col sm={9} className="logoContainer">
                        <Row className="logoContainerRow">
                            <Col sm="auto" className="logoImage">
                                <NavLink className="logoLink" key="Home" to="/" >
                                    <img src={clientConfig?.DEFAULT_LOGO} className="logo" alt={clientConfig?.DEFAULT_TITLE} />
                                </NavLink>
                            </Col>
                            <Col sm="auto" className="programName">
                                <NavLink className="logoLink" key="Home" to="/" >
                                    {clientConfig ? (
                                        <div dangerouslySetInnerHTML={{ __html: clientConfig.DEFAULT_TITLE }}></div>
                                    ) : (<div>An unknown error has occurred.  No site available.</div>)}
                                </NavLink>
                            </Col>
                        </Row>
                    </Col>
                    <Col sm={2}>
                        <Row>
                            <div className="mainMenuTabs desktopView">
                                <TopNavigation />
                            </div>
                        </Row>
                    </Col>
                </Row>
                <Row className="mainMenuTabs mobileView">
                    <Col>
                        <div className="hamburgerLabel" onClick={showHideMobileNavigation} />
                        {showMobileNavigation && (
                            <div className="closeMenuButton" onClick={showHideMobileNavigation} />
                        )}
                        {showMobileNavigation ? (
                            <div className="showHideNavigation">
                                <TopNavigation />
                            </div>
                        ) : (<></>)}
                    </Col>
                </Row>
            </header>
        );
    } else {
        return (<></>);
    }
}
